<template>
  <div>
      <div class="content-header">
        <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
            <b-skeleton width="150px" height="2.5em"></b-skeleton>
            </div>
        </div>
        </div>
        <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
            <b-skeleton width="90px" height="2.5em"></b-skeleton>
            </div>
        </div>
        </div>
    </div>
   <section class="content">
      <div class="container-fluid mt-3 mt-md-1">
          <div class="row">
              <div class="col-12 col-md-6 p-1 p-md-3">
                  <div class="card p-3" style="margin-bottom:0.1rem; !important; display: flow-root;">
                        <b-skeleton width="150px"></b-skeleton>
                        <b-skeleton width="60px" style="text-align: right;" height="4rem" class="float-right p-1 mr-4 mr-xl-5"></b-skeleton>
                  </div>
              </div>
              <div class="col-12 col-md-6 p-1 p-md-3">
                  <div class="card p-3" style="margin-bottom:0.1rem; !important; display: flow-root;">
                        <b-skeleton width="150px"></b-skeleton>
                        <b-skeleton width="60px" style="text-align: right;" height="4rem" class="float-right p-1 mr-4 mr-xl-5"></b-skeleton>
                  </div>
              </div>
              <div class="col-12 col-md-6 p-1 p-md-3">
                  <div class="card p-3" style="margin-bottom:0.1rem; !important; display: flow-root;">
                        <b-skeleton width="150px"></b-skeleton>
                        <b-skeleton width="60px" style="text-align: right;" height="4rem" class="float-right p-1 mr-4 mr-xl-5"></b-skeleton>
                  </div>
              </div>
              <div class="col-12 col-md-6 p-1 p-md-3">
                  <div class="card p-3" style="margin-bottom:0.1rem; !important; display: flow-root;">
                        <b-skeleton width="150px"></b-skeleton>
                        <b-skeleton width="60px" style="text-align: right;" height="4rem" class="float-right p-1 mr-4 mr-xl-5"></b-skeleton>
                  </div>
              </div>
              
          </div>
      </div>
    </section>
  </div>
</template>

<style>
@import "../../../public/custom_styles/profile.css";
</style>

<script>
export default {
  data() {
    return {
      loading: true
    };
  },
  
};
</script>
